import { render, staticRenderFns } from "./AiRirekishoPreview.vue?vue&type=template&id=7db66b60"
import script from "./AiRirekishoPreview.vue?vue&type=script&lang=js"
export * from "./AiRirekishoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports